<div class="welcome-page">
  <!-- Subtle grid texture -->
  <div class="grid-texture" aria-hidden="true"></div>

  <!-- Header -->
  <header class="welcome-header">
    <div class="header-inner">
      <a class="logo-link">
        <img src="/assets/images/qira-logo-black-blue.svg" alt="Qira" class="logo">
      </a>

      <div class="header-right" *ngIf="isAuthenticated">
        <button type="button"
                class="user-chip"
                [matMenuTriggerFor]="userMenu"
                aria-label="Account menu">
          <span class="user-avatar">{{ initials }}</span>
          <span class="user-name">{{ user?.name }}</span>
          <mat-icon class="user-chevron">expand_more</mat-icon>
        </button>

        <mat-menu #userMenu="matMenu" class="qira-user-menu qira-user-menu--welcome">
          <div class="qira-user-menu__profile" mat-menu-item disabled>
            <div class="qira-user-menu__avatar">{{ initials }}</div>
            <div class="qira-user-menu__identity">
              <span class="qira-user-menu__name">{{ user?.name }}</span>
              <span class="qira-user-menu__email">{{ user?.email }}</span>
            </div>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="onLogOut()" class="qira-user-menu__danger">
            <mat-icon>logout</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </header>

  <!-- Hero + cards -->
  <main class="welcome-main">
    <section class="hero">
      <span class="eyebrow">
        <svg class="sparkle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"></path>
        </svg>
        Property Manager Dashboard
      </span>
      <h1 class="hero-title">
        <span>Welcome to</span>
        <img src="/assets/images/qira-logo-black-blue.svg" alt="Qira" class="hero-logo">
      </h1>
      <p class="hero-subtitle">Choose the platform area you want to manage.</p>
    </section>

    <section class="product-grid">
      <!-- Security Deposit card (cyan accent) -->
      <button type="button" class="product-card cyan" (click)="onSecurityDeposit()">
        <span class="card-glow" aria-hidden="true"></span>
        <span class="card-top-bar" aria-hidden="true"></span>

        <div class="card-head">
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <polyline points="9 12 11 14 15 10"></polyline>
            </svg>
          </div>
          <span class="eyebrow-tag">Deposits</span>
        </div>

        <h2 class="card-title">Security Deposit Management</h2>
        <p class="card-desc">Manage applications, deposits, renewals, claims, refunds, and resident communication.</p>

        <ul class="card-bullets">
          <li><span class="dot"></span>Applications &amp; renewals</li>
          <li><span class="dot"></span>Claims &amp; refunds</li>
          <li><span class="dot"></span>Resident messaging</li>
        </ul>

        <div class="card-cta-wrap">
          <span class="card-cta">
            Open Security Deposit
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </span>
        </div>
      </button>

      <!-- Rent Management card (magenta accent) -->
      <button type="button" class="product-card magenta" (click)="onRentManagement()">
        <span class="card-glow" aria-hidden="true"></span>
        <span class="card-top-bar" aria-hidden="true"></span>

        <div class="card-head">
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="6" width="20" height="13" rx="2" ry="2"></rect>
              <path d="M16 12h4"></path>
              <path d="M2 10h20"></path>
            </svg>
          </div>
          <span class="eyebrow-tag">Rent</span>
        </div>

        <h2 class="card-title">Rent Management</h2>
        <p class="card-desc">Manage rent payments, Pay Later activity, payment status, and resident payment workflows.</p>

        <ul class="card-bullets">
          <li><span class="dot"></span>Rent payments &amp; status</li>
          <li><span class="dot"></span>Pay Later activity</li>
          <li><span class="dot"></span>Payment workflows</li>
        </ul>

        <div class="card-cta-wrap">
          <span class="card-cta">
            Open Rent Management
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </span>
        </div>
      </button>
    </section>

    <!-- Support strip -->
    <section class="support-strip">
      <div class="support-left">
        <span class="support-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="4"></circle>
            <line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line>
            <line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line>
            <line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line>
            <line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>
          </svg>
        </span>
        <div class="support-text">
          <p class="support-title">Need help?</p>
          <p class="support-sub">Contact Qira Support for assistance.</p>
        </div>
      </div>
      <a href="mailto:support@qira.com" class="support-cta">
        Contact Support
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </a>
    </section>
  </main>
</div>
